// "Olvidé mi contraseña": pedir el link por mail y, con el link, elegir una
// contraseña nueva. El token viaja en el fragmento (#) de la URL: no llega a
// los registros de ningún servidor ni se manda como Referer.
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Alert, Anchor, Button, Center, Paper, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core';
import { api, mensajeDeError } from '../api.ts';

function Marco({ titulo, children }: { titulo: string; children: React.ReactNode }) {
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="sm" p="xl" w={400} maw="100%">
        <Stack>
          <div>
            <Title order={2}>epms</Title>
            <Text c="dimmed" size="sm">{titulo}</Text>
          </div>
          {children}
          <Anchor component={Link} to="/login" size="xs" ta="center">Volver al ingreso</Anchor>
        </Stack>
      </Paper>
    </Center>
  );
}

export function Recuperar() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [listo, setListo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  async function pedir(e: React.FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      const r = await api.post<{ mensaje: string }>('/api/auth/recuperar', { email });
      setListo(r.mensaje);
    } catch (x) {
      setError(mensajeDeError(x));
    } finally {
      setEnviando(false);
    }
  }
  return (
    <Marco titulo="Recuperar el acceso">
      {listo ? <Alert color="teal">{listo} Revisá también el correo no deseado.</Alert> : (
        <form onSubmit={pedir}>
          <Stack>
            {error && <Alert color="red">{error}</Alert>}
            <Text size="sm">Te mandamos un link para elegir una contraseña nueva. El segundo factor se sigue pidiendo al entrar.</Text>
            <TextInput label="Email" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
            <Button type="submit" loading={enviando}>Mandarme el link</Button>
          </Stack>
        </form>
      )}
    </Marco>
  );
}

export function Restablecer() {
  const navegar = useNavigate();
  const token = window.location.hash.replace(/^#/, '');
  const [password, setPassword] = useState('');
  const [repetida, setRepetida] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const valida = password.length >= 12 && /[a-zA-Z]/.test(password) && /\d/.test(password);
  async function guardar(e: React.FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await api.post('/api/auth/restablecer', { token, password });
      // Se borra el token de la barra de direcciones y del historial.
      window.history.replaceState(null, '', '/restablecer');
      navegar('/login?restablecida=1', { replace: true });
    } catch (x) {
      setError(mensajeDeError(x));
    } finally {
      setEnviando(false);
    }
  }
  if (!/^[A-Za-z0-9_-]{43}$/.test(token)) {
    return <Marco titulo="Elegir contraseña nueva"><Alert color="red">El link no es válido. Pedí uno nuevo desde "¿Olvidaste tu contraseña?".</Alert></Marco>;
  }
  return (
    <Marco titulo="Elegir contraseña nueva">
      <form onSubmit={guardar}>
        <Stack>
          {error && <Alert color="red">{error}</Alert>}
          <PasswordInput label="Contraseña nueva" description="Mínimo 12 caracteres, con letras y números" autoComplete="new-password" required autoFocus
            value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
          <PasswordInput label="Repetila" autoComplete="new-password" required value={repetida} onChange={(e) => setRepetida(e.currentTarget.value)}
            error={repetida && repetida !== password ? 'No coinciden' : undefined} />
          <Button type="submit" loading={enviando} disabled={!valida || password !== repetida}>Guardar</Button>
        </Stack>
      </form>
    </Marco>
  );
}
